export default __webpack_public_path__ + "static/media/bg2.9e7c6337.jpg";